import { Injectable } from '@angular/core';
import { SignalingMessage } from 'src/app/models/signaling-message/signaling-message';
import { DataChannelService } from '../data-channel/data-channel.service';
import { SignalingTransportService } from '../signaling-transport/signaling-transport.service';

type MessageCallback = (message: any) => Promise<void>;

@Injectable({
  providedIn: 'root'
})
export class SignalingService {

  counts: { [key: string]: number } = {};
  onMessage: MessageCallback;
  roomId: string;
  senderId: string;

  constructor(
    private dataChannel: DataChannelService,
    private transport: SignalingTransportService,
  ) {}

  public async connect(roomId: string, senderId: string, onMessage: MessageCallback) {
    this.roomId = roomId;
    this.senderId = senderId;
    this.onMessage = onMessage;
    this.transport.connect(roomId, senderId);
    await this.setupOnMessage();
  }

  public reconnect() {
    this.transport.unsubscribe();
  }

  public async setupOnMessage() {
    await this.transport.subscribe(this.roomId, this.senderId, async (data) => {
      try {
        if (data && this.onMessage) {
          await this.onMessage(data);
        }
      } catch (err) {
        console.error('SignalingService: Invalid message', data, err.message);
      }
    });
  }

  public async disconnect() {
    if (this.onMessage) {
      this.onMessage = null;
    }
    this.transport.disconnect(this.roomId);
    this.roomId = null;
    this.senderId = null;
    this.counts = {};
  }

  public async send(msg: any, uid?: string) {
    if (!uid) {
      uid = null;
    }

    this.createCount(msg.to);
    this.counts[msg.to]++;

    await this.processMessage(new SignalingMessage(uid, msg));
  }

  private createCount(id: string) {
    if (!this.counts[id]) {
      this.counts[id] = 0;
    }
  }

  private async processMessage(message: SignalingMessage) {
    if (this.dataChannel.dcs[message.msg.to]?.readyState === 'open' && !message.msg.ice) {
      await this.dataChannel.send(message.msg.to, 'signaling', JSON.stringify(message.msg));
    } else {
      await this.transport.publish(this.roomId, message.msg.to, message.msg);
    }
  }
}
